import { NavLink } from 'react-router-dom';
import type { Role } from '@mdu-invoicing/shared';
import { navForRole, type NavItem } from './nav';
import { cn } from '@/lib/cn';

const GROUP_LABELS: Record<NavItem['group'], string | null> = {
  main: null,
  staff: 'Équipe Unifiber',
  ref: 'Référence',
};

export function Sidebar({
  role,
  canViewAmounts,
  canManageUsers,
}: {
  role: Role | undefined;
  canViewAmounts: boolean;
  canManageUsers: boolean;
}) {
  const items = navForRole(role, canViewAmounts, canManageUsers);
  let lastGroup: NavItem['group'] | null = null;

  return (
    <aside className="hidden w-64 shrink-0 flex-col border-r border-slate-200 bg-white lg:flex">
      {/* Brand */}
      <div className="flex h-16 items-center gap-2.5 px-5">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-gradient text-sm font-extrabold text-white">
          M
        </div>
        <div className="leading-tight">
          <div className="text-sm font-extrabold gradient-text">MDU Invoicing</div>
          <div className="text-[10px] font-medium uppercase tracking-wide text-slate-400">Unifiber</div>
        </div>
      </div>

      <nav className="flex-1 space-y-0.5 overflow-y-auto px-3 py-2 custom-scrollbar">
        {items.map((item) => {
          const showGroup = item.group !== lastGroup && GROUP_LABELS[item.group];
          lastGroup = item.group;
          return (
            <div key={item.path}>
              {showGroup && (
                <div className="px-3 pb-1 pt-4 text-[10px] font-bold uppercase tracking-wider text-slate-400">
                  {GROUP_LABELS[item.group]}
                </div>
              )}
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  cn(
                    'group flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-brand-purple/10 text-brand-purple'
                      : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900',
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <item.icon
                      className={cn('h-5 w-5 shrink-0', isActive ? 'text-brand-rose' : 'text-slate-400 group-hover:text-slate-600')}
                      strokeWidth={2}
                    />
                    <span className="truncate">{item.label}</span>
                  </>
                )}
              </NavLink>
            </div>
          );
        })}
      </nav>

      <div className="border-t border-slate-100 px-5 py-3 text-[10px] text-slate-400">
        Mois de facturation · <span className="font-semibold text-slate-500">Juin 2026</span>
      </div>
    </aside>
  );
}
